<template lang="pug">
    footer#footer
        router-link(:to="{ name: 'home' }", tag="h1")
            | Elissa Village
            SvgIcon(data="@svgs/logos/logo_full.svg")
        small &copy; {{ year }}. Elissa Village. Todos os direitos reservados.
</template>

<script>
export default {
    name: "component-footer",
    computed: {
        year() {
            return new Date().getFullYear()
        }
    },
}
</script>

<style lang="stylus" scoped src="./Footer.styl"></style>